module.exports = {"data":[{"id_code":1,"ds_name":"Sin iniciar"},{"id_code":2,"ds_name":"Iniciada"},{"id_code":3,"ds_name":"Culminada"},{"id_code":4,"ds_name":"Cancelada"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/strategicTracking/states_list.json
// module id = 536
// module chunks = 0